class Vector2 {
  x: number
  y: number

  constructor(x = 0, y = 0) {
    this.x = x
    this.y = y
  }

  // Add vector to self
  add(vectorInput: Vector2) {
    this.x += vectorInput.x
    this.y += vectorInput.y
    return this
  }
  // Subtract vector to self
  sub(vectorInput: Vector2) {
    this.x -= vectorInput.x
    this.y -= vectorInput.y
    return this
  }
  // Multiply vector to self
  mul(vectorInput: Vector2) {
    this.x *= vectorInput.x
    this.y *= vectorInput.y
    return this
  }
  // Divide vector to self
  div(vectorInput: Vector2) {
    this.x /= vectorInput.x
    this.y /= vectorInput.y
    return this
  }

  // Add vector to self
  addNum(input: number) {
    this.x += input
    this.y += input
    return this
  }
  // Subtract vector to self
  subNum(input: number) {
    this.x -= input
    this.y -= input
    return this
  }
  // Multiply vector to self
  mulNum(input: number) {
    this.x *= input
    this.y *= input
    return this
  }
  // Divide vector to self
  divNum(input: number) {
    this.x /= input
    this.y /= input
    return this
  }

  // Add two vectors
  static addVector2(v1: Vector2, v2: Vector2) {
    return new Vector2(
      v1.x + v2.x,
      v1.y + v2.y,
    )
  }
  // Subtract two vectors
  static subVector2(v1: Vector2, v2: Vector2) {
    return new Vector2(
      v1.x - v2.x,
      v1.y - v2.y,
    )
  }
  // Multiply two vectors
  static mulVector2(v1: Vector2, v2: Vector2) {
    return new Vector2(
      v1.x * v2.x,
      v1.y * v2.y,
    )
  }
  // Divide two vectors
  static divVector2(v1: Vector2, v2: Vector2) {
    return new Vector2(
      v1.x / v2.x,
      v1.y / v2.y,
    )
  }

  // Add number to vector
  static addNumVector2(inputVector: Vector2, inputNumber: number) {
    return new Vector2(
      inputVector.x + inputNumber,
      inputVector.y + inputNumber,
    )
  }
  // Subtract number to vector
  static subNumVector2(inputVector: Vector2, inputNumber: number) {
    return new Vector2(
      inputVector.x - inputNumber,
      inputVector.y - inputNumber,
    )
  }
  // Multiply number to vector
  static mulNumVector2(inputVector: Vector2, inputNumber: number) {
    return new Vector2(
      inputVector.x * inputNumber,
      inputVector.y * inputNumber,
    )
  }
  // Divide number to vector
  static divNumVector2(inputVector: Vector2, inputNumber: number) {
    return new Vector2(
      inputVector.x / inputNumber,
      inputVector.y / inputNumber,
    )
  }
}

export default Vector2
